import React, { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { StyledTableCell } from "../../../MaterialTheme/themes";
import { sortingState } from "../../../Store/atoms";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { makeStyles } from "@material-ui/core";

import "./TableHeadCell.css";
import { TableColumn } from "../../../Models/Entities";

const useStyles = makeStyles({
  hidden: {
    visibility: "hidden",
  },
});

interface ITableHeadCellProps {
  name: string;
  active: boolean;
  columnType: TableColumn;
}

const TableHeadCell = ({ name, active, columnType }: ITableHeadCellProps) => {
  const classes = useStyles();
  const setSorting = useSetRecoilState(sortingState);
  const [displayIcon, setDisplayIcon] = useState(false);
  const [sortAscending, setSortAscending] = useState(true);

  const sortIcon = sortAscending ? (
    <KeyboardArrowUpIcon className={displayIcon ? "" : classes.hidden} />
  ) : (
    <KeyboardArrowDownIcon className={displayIcon ? "" : classes.hidden} />
  );

  const handleMouseEnter = () => {
    setDisplayIcon(true);
  };
  const handleMouseLeave = () => {
    setDisplayIcon(false);
  };

  const handleClick = () => {
    setSortAscending((sortAscending) => !sortAscending);
    setSorting({ column: columnType, ascending: sortAscending });
  };

  return (
    <StyledTableCell
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div className="head-cell">
        <div className="head-cell-name">{name}</div>

        {sortIcon}
      </div>
    </StyledTableCell>
  );
};

export default TableHeadCell;
